module.exports = __webpack_public_path__ + "img/valentines-day-2026.dbb6f123.jpg";